import NiceSelect from '../vendor/nice-select2.js';

class JobsFilter {
  constructor(element, form) {
    this.element = element;
    this.sections = this.element.querySelectorAll('[data-element="jobs-section"]');
    this.items = this.element.querySelectorAll('[data-element="jobs-item"]');
    this.message = this.element.querySelector('[data-element="jobs-message"]');
    this.resetBtn = this.element.querySelector('[data-element="jobs-reset-btn"]');

    this.form = form;
    this.searchTitle = this.form.querySelector('[data-search="title"]');
    this.searchDepartment = this.form.querySelector('[data-search="department"]');
    this.searchLocation = this.form.querySelector('[data-search="location"]');
  }

  init() {
    this.setNiceSelect();
    this.form.addEventListener('submit', this.formOnSubmit.bind(this));
    this.form.addEventListener('reset', this.formOnReset.bind(this));
  }

  // Needs to use the document object in order to init the NiceSelect
  setNiceSelect() {
    this.searchDepartmentNiceSelect = new NiceSelect(document.querySelector('[data-search="department"]'));
    this.searchLocationNiceSelect = new NiceSelect(document.querySelector('[data-search="location"]'));
  }

  clearMessage() {
    this.message.textContent = '';
  }

  scrollIntoView() {
    this.element.scrollIntoView();
  }

  showResetButton() {
    this.resetBtn.classList.add('jobs__form-reset--visible');
  }

  hideResetButton() {
    this.resetBtn.classList.remove('jobs__form-reset--visible');
  }

  formOnSubmit(event) {
    event.preventDefault();
    event.stopPropagation();

    this.clearMessage();

    if (
      '' === this.searchTitle.value &&
      '' === this.searchDepartment.value &&
      '' === this.searchLocation.value
    ) {
      this.showAll();
      return false;
    }

    this.filter();
  }

  formOnReset() {
    this.searchDepartmentNiceSelect.update();
    this.searchLocationNiceSelect.update();
    this.clearMessage();
    this.showAll();
    this.scrollIntoView();
  }

  showAll() {
    this.hideResetButton();

    this.sections.forEach((element) => {
      element.classList.remove(
        'jobs__section--hidden',
        'jobs__section--filtered-even',
        'jobs__section--filtered-odd'
      );
    });

    this.items.forEach((element) => {
      element.classList.remove('jobs__item--hidden');
    });
  }

  filter() {
    const titleValue = this.searchTitle.value.toLowerCase();
    const departmentValue = this.searchDepartment.value.toLowerCase();
    const locationValue = this.searchLocation.value.toLowerCase();

    this.items.forEach((element) => {
      const itemTitle = element.dataset.elementTitle.toLowerCase();
      const itemDepartment = element.dataset.elementDepartment.toLowerCase();
      const itemLocation = element.dataset.elementLocation.toLowerCase();

      const matches = [];
      const valuesToCheck = [
        [titleValue, itemTitle],
        [departmentValue, itemDepartment],
        [locationValue, itemLocation],
      ];

      const conditions = valuesToCheck.filter((condition) => {
        if (condition[0] !== '') {
          return true;
        }
      });

      conditions.forEach((condition) => {
        if (condition[1].includes(condition[0]) === true) {
          matches.push(true);
        } else {
          matches.push(false);
        }
      });

      if (matches.includes(false) === false) {
        element.classList.remove('jobs__item--hidden');
      } else {
        element.classList.add('jobs__item--hidden');
      }
    });

    this.checkForEmptyItems();
    this.checkForEmptySections();
    this.scrollIntoView();
  }

  checkForEmptyItems() {
    this.sections.forEach((section) => {
      const itemsGrid = section.querySelector('.grid-four-col');
      const totalItems = itemsGrid.children.length;
      let hiddenCounter = 0;

      for (const item of itemsGrid.children) {
        if (item.classList.contains('jobs__item--hidden') === true) {
          hiddenCounter++;
        }
      }

      if (totalItems === hiddenCounter) {
        section.classList.add('jobs__section--hidden');
      } else {
        section.classList.remove('jobs__section--hidden');
      }
    });
  }

  checkForEmptySections() {
    let hiddenCounter = 0;
    let visibleCounter = 0;
    const totalSections = this.sections.length;

    this.sections.forEach((section) => {
      if (section.classList.contains('jobs__section--hidden') === true) {
        hiddenCounter++;
      } else {
        if (visibleCounter % 2 === 0) {
          section.classList.remove('jobs__section--filtered-odd');
          section.classList.add('jobs__section--filtered-even');
        } else {
          section.classList.remove('jobs__section--filtered-even');
          section.classList.add('jobs__section--filtered-odd');
        }

        visibleCounter++;
      }

      if (totalSections === hiddenCounter) {
        this.message.textContent = 'No results exist with your search parameters.';
      } else {
        this.showResetButton();
      }
    });
  }
}

const jobsFilter = {
  init() {
    const jobs = document.querySelector('[data-module="jobs"]');

    if (jobs) {
      const form = jobs.querySelector('[data-element="jobs-form"]');

      if (form) {
        const jobsFilter = new JobsFilter(jobs, form);
        jobsFilter.init();
      }
    }
  },
};

export default jobsFilter;
